// Package Block
import axios from "axios";
import { v4 as uuid } from "uuid";

// Configuration Block
import {
  LOGIN_URL,
  REGISTER_URL,
  RESET_PASSWORD_URL,
  ME_URL,
  PRESIGNED_URL,
  USER_URL,
} from "../../../../constants/config";

export function login(username, password) {
  return axios.post(LOGIN_URL, { username, password });
}

export async function loginWithPin(username, pin) {
  const response = await fetch(LOGIN_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      username,
      login_pin: pin,
    }),
  });

  if (!response.ok) {
    let errorMessage = "Login failed. Please try again.";

    try {
      const errorData = await response.json();
      if (errorData.errors?.length) {
        errorMessage = errorData.errors[0];
      } else if (errorData.message) {
        errorMessage = errorData.message;
      }
    } catch (error) {
      console.error("Error parsing response:", error);
    }

    throw new Error(errorMessage);
  }

  return response.json();
}


export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return axios.post(`${RESET_PASSWORD_URL}/url`, { email });
}
export function resetPassword(otp, email, password) {
  return axios.post(`${RESET_PASSWORD_URL}`, { otp, email, password });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}

export function updateProfilePictureRequest(payload) {
  const key = [{ key: `media/tenant-users/images/${uuid()}` }];
  return axios.post(PRESIGNED_URL, key);
}
export function uploadImageToCloud(payload) {
  return fetch(payload.url, {
    method: "PUT",
    body: payload.image,
  });
}

export function saveImageUrl(userId, payload) {
  return axios.patch(`${USER_URL}/${userId}`, payload);
}
export function updateUser(userId, payload) {
  return axios.patch(`${USER_URL}/${userId}`, payload);
}
